<div class="right-side p-5">
  <!-- ================= Invoice Section ================= -->
  <div class="section">
    <div class="bkgimage">
      <form [formGroup]="invoiceStatusForm">

        <!-- Header -->
        <div class="row">
          <div class="col-12 text-start mb-4">
            <h2>Invoice Details Submitted</h2>
          </div>
        </div>

        <!-- ================= Event Details ================= -->
        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="eventId">Event ID :</label>
            <input class="form-control" type="text" id="eventId" formControlName="eventId" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="eventName">Event Name :</label>
            <input class="form-control" type="text" id="eventName" formControlName="eventName" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="intervention">Intervention :</label>
            <input class="form-control" type="text" id="intervention" formControlName="intervention" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="component">Component :</label>
            <textarea id="component" class="form-control" formControlName="component"></textarea>
          </div>
        </div>

        <!-- ================= Invoice Basic Info ================= -->
        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="eventStatus">Event Status :</label>
            <input class="form-control" type="text" id="eventStatus" formControlName="eventStatus" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="invoiceID">Invoice ID :</label>
            <input class="form-control" type="text" id="invoiceID" formControlName="invoiceID" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="date">Invoice Created Date :</label>
            <input class="form-control" type="date" id="date" formControlName="date" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="ratePerMSME">Rate per MSME (₹) :</label>
            <input class="form-control" type="text" id="ratePerMSME" formControlName="ratePerMSME" />
          </div>
        </div>

        <!-- ================= MSME Details ================= -->
        <div class="row">
          
          <div class="col-md-3 mb-3">
            <label for="noOfMSMEAttended">No. of MSME Attended :</label>
            <input class="form-control" type="text" id="noOfMSMEAttended" formControlName="noOfMSMEAttended" />
          </div>

          <div class="col-md-3 mb-3">
            <label for="verified">Eligible MSME :</label>
            <input class="form-control" type="text" id="verified" formControlName="verified" />
            <!-- <span class="ms-2">{{ verified }}</span>-->
          </div>

          <div class="col-md-3 mb-3">
            <label for="nonEligible">Non Eligible MSME :</label>
            <input class="form-control" type="text" id="nonEligible" formControlName="nonEligible" />
            <!-- <span class="ms-2">{{ verified }}</span>-->
          </div>

          <div class="col-md-3 mb-3">
            <label for="unverifiedMSME">Unverified MSME :</label>
            <input class="form-control" type="text" id="unVerifiedMSMECount" formControlName="unVerifiedMSMECount" />
            <!-- <span class="ms-2">{{ unVerifiedMSMECount }}</span>-->
          </div>
          <!-- <div class="col-md-3 mb-3">
     <label>Unverified MSME :</label>
     <span class="ms-2">{{ unVerifiedMSMECount }}</span>
   </div>-->
        </div>

        <!-- ================= Calculation Section ================= -->
        <div class="row">
          <div class="col-md-2 mb-3">
            <label for="total">Total (₹) :</label>
            <input class="form-control" type="text" id="total" formControlName="total" />
          </div>

          <div class="col-md-2 mb-3">
            <label for="gstType">GST Type :</label>
            <input class="form-control" type="text" id="gstType" formControlName="gstType" readonly />
          </div>

          <div class="col-md-2 mb-3">
            <label for="gstPercent">GST Percent (%) :</label>
            <input class="form-control" type="text" id="gstPercent" formControlName="gstPercent" readonly />
          </div>

          <div class="col-md-2 mb-3">
            <label for="totalGST">Total GST (₹) :</label>
            <input class="form-control" type="text" id="totalGST" formControlName="totalGST" readonly />
          </div>

          <div class="col-md-2 mb-3">
            <label for="finalTotal">Final Total (₹) :</label>
            <input class="form-control" type="text" id="finalTotal" formControlName="finalTotal" />
          </div>
        </div>

        <!-- ================= Invoice Download ================= -->
        <div class="row">
          <div class="col-md-3">
            <mat-label>Download Invoice :</mat-label>
            <mat-card-content>
              <a class="btn btn-warning btn-sm mt-1" style="cursor: pointer" (click)="onDownloadInvoice()">
                <i class="bi bi-download"></i> Download
              </a>

              <button class="btn btn-primary btn-sm mx-2 mt-1" type="button" (click)="openFilePreviewDialog()">
                <i class="bi bi-eye"></i> View File
              </button>
            </mat-card-content>
          </div>
        </div>

        <!-- ================= Payment Details ================= -->
        <div class="row mt-3">
          <div class="col-12 text-start mb-4">
            <h2>Payment Details By MSSIDC</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="statusName">Invoice Status :</label>
            <input class="form-control" type="text" id="statusName" formControlName="statusName" />
          </div>
        </div>

        <!-- ================= Action Buttons ================= -->
        <div class="text-center mt-4">
          <button class="btn btn-success me-2" type="button" (click)="onInvoiceAccept()" *ngIf="showButton">
            Accept the Invoice
          </button>

          <button class="btn btn-danger" type="button" (click)="onInvoiceReject()" *ngIf="showButton">
            Reject the Invoice
          </button>
        </div>

        <div class="text-center mt-4">
          <button class="btn btn-info" type="button" (click)="onCancel()">
            Back
          </button>
        </div>

      </form>
    </div>
  </div>

  <!-- ================= MSME Participants Section ================= -->
  <div class="section mt-4">

    <div class="row align-items-center mb-2">
      <div class="col">
        <strong>List of Attended MSME Participants</strong>
      </div>
      <div class="col text-end">
        <button type="button" class="btn btn-sm btn-success" (click)="exportToExcel()">
          <i class="bi bi-file-earmark-excel"></i> Export To Excel
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matSort matSortActive="enrollmentId" matSortDirection="asc" matSortDisableClear>

        <!-- Columns -->
        <ng-container matColumnDef="rowNum">
          <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
          <td mat-cell *matCellDef="let row">{{ row.rowNum }}</td>
        </ng-container>

        <ng-container matColumnDef="udyamRegistrationNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Registration Number</th>
          <td mat-cell *matCellDef="let row">{{ row.udyamRegistrationNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="udyamMobileNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Mobile Number</th>
          <td mat-cell *matCellDef="let row">{{ row.udyamMobileNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="enterpriseName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Enterprise Name</th>
          <td mat-cell *matCellDef="let row">{{ row.enterpriseName }}</td>
        </ng-container>

        <ng-container matColumnDef="ownerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner Name</th>
          <td mat-cell *matCellDef="let row">{{ row.ownerName }}</td>
        </ng-container>

        <ng-container matColumnDef="participantName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Participant Name</th>
          <td mat-cell *matCellDef="let row">{{ row.participantName }}</td>
        </ng-container>

        <ng-container matColumnDef="mobileNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
          <td mat-cell *matCellDef="let row">{{ row.mobileNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="emailId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email ID</th>
          <td mat-cell *matCellDef="let row">{{ row.emailId }}</td>
        </ng-container>

        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
          <td mat-cell *matCellDef="let row">{{ row.designation }}</td>
        </ng-container>

        <ng-container matColumnDef="enrollmentId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Enrollment ID</th>
          <td mat-cell *matCellDef="let row">{{ row.enrollmentId }}</td>
        </ng-container>

        <!-- Header & Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- No Data -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="10">No data matching the filter</td>
        </tr>

      </table>
    </div>

    <!-- Paginator -->
    <mat-paginator #paginator class="demo-paginator" [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [pageIndex]="pageIndex" [showFirstLastButtons]="showFirstLastButtons" [hidePageSize]="hidePageSize" (page)="onPageChange($event)" aria-label="Select page">
    </mat-paginator>

  </div>
</div>
